import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { TwoFaSteps } from '../../SetupTwoFaPage.constant'
import { SetupStepsTypes } from '../../SetupTwoFaPage.types'
import { SetupTwoFaWrapper } from '../SetupTwoFaWrapper'

export const SetupTwoFaConfirmation: FC<SetupStepsTypes> = ({
  setCurrentStep,
  onSubmit
}) => {
  const { t } = useTranslation('auth', {
    keyPrefix: 'setup_two_fa_view.confirmation'
  })

  return (
    <SetupTwoFaWrapper
      title={t('title')}
      description={t('description')}
      primaryButtonLabel={t('setup_button')}
      secondaryButtonLabel={t('skip_button')}
      onPrimaryButtonClick={() => setCurrentStep(TwoFaSteps.SETUP_TWO_FA)}
      onSecondaryButtonClick={onSubmit}
      currentStep={TwoFaSteps.SETUP_CONFIRMATION}
    />
  )
}
